module.exports = __webpack_public_path__ + "static/media/emperor.0381cb2b.gif";